// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import HttpClient from './libs/http_client';
import commonFuncs from './libs/common_funcs'

Vue.use(iView);

// axios 跨域问题
import axios from 'axios'
Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'  //关键代码
axios.defaults.baseURL = '/wxapp-api'  //关键代码
Vue.config.productionTip = false;

// 通用方法
Vue.prototype.httpClient = new HttpClient();
for (let fn in commonFuncs) {
	Vue.prototype[fn] = commonFuncs[fn]
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  iView.LoadingBar.finish();
});

/* 通用过滤器 */
// 图片
import {qiniuImageView3} from './filters/qiniu_imageview3'
Vue.filter('qiniuImageView3', qiniuImageView3)
import {qiniuResource, videoImgUrl} from './filters/qiniu_resource'
Vue.filter('qiniuResource', qiniuResource)
Vue.filter('videoImgUrl', videoImgUrl)

import NoData from './components/common/no_data.vue'
Vue.component('no-data', NoData)


// 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js